import React from "react";
import { Outlet, NavLink, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, Tags, Award, MessageSquare, FileText, Users, Star, Percent, Home, Settings, Image, LogOut, Search, Menu, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/brands", label: "Brands", icon: Award },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
  { to: "/admin/quotations", label: "Quotations", icon: FileText },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/reviews", label: "Reviews", icon: Star },
  { to: "/admin/offers", label: "Offers", icon: Percent },
  { to: "/admin/homepage", label: "Homepage", icon: Home },
  { to: "/admin/media", label: "Media", icon: Image },
  { to: "/admin/seo", label: "SEO", icon: Search },
  { to: "/admin/navigation", label: "Navigation", icon: Menu },
  { to: "/admin/activity", label: "Activity", icon: Activity },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="p-8">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace/>;
  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <aside className="w-64 bg-[#0F172A] text-white flex flex-col shrink-0 hidden md:flex">
        <Link to="/admin" className="p-5 flex items-center gap-2 border-b border-white/10">
          <div className="w-10 h-10 bg-[#EA580C] rounded-md flex items-center justify-center font-heading font-extrabold">RX</div>
          <div><div className="font-heading font-extrabold">REXTECH</div><div className="text-xs text-slate-400">Admin</div></div>
        </Link>
        <nav className="flex-1 p-3 space-y-1 overflow-auto">
          {LINKS.map(l => (
            <NavLink key={l.to} to={l.to} end={l.end}
              className={({isActive}) => `flex items-center gap-2 px-3 py-2 rounded-md text-sm ${isActive ? "bg-[#EA580C] text-white" : "text-slate-300 hover:bg-white/10"}`}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}>
              <l.icon className="w-4 h-4"/> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="text-xs text-slate-400 mb-2">{user.email}</div>
          <Button variant="outline" size="sm" onClick={logout} className="w-full bg-transparent border-white/20 text-white hover:bg-white hover:text-[#0F172A]" data-testid="admin-logout">
            <LogOut className="w-4 h-4 mr-1"/> Logout
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-8"><Outlet/></main>
    </div>
  );
}
